import styled from 'styled-components';

import { Button, media, NavLink } from '@minerva-analytics/pantheon';

import { BLUE, WHITE } from 'root/theme';

const UserSummaryBannerContainer = styled.div`
  background-color: ${BLUE};
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 50px;
  border: 2px solid ${BLUE};
  height: 5rem;
  max-width: 1000px;
  margin: 0 auto;
  margin-bottom: 50px;
  overflow: hidden;
  ${(props) => props.stats
    ? `
    justify-content: space-around;
    `
    : `justify-content: space-between;
      padding: 1rem 2rem;
    `}
  margin-top: 50px;
  ${media.medium`
    flex-direction: column;
    height: inherit;
    border-radius: 10px;
  `}
`;

const TrackingText = styled.div`
  color: ${WHITE};
  ${media.medium`
    width: 10rem;
    text-align: center;
    padding-bottom: 0.5rem;
  `}
`;

const AuthButton = styled(Button).attrs({
  border: WHITE,
  color: WHITE,
  background: BLUE,
})`
  width: 12rem;
  color: ${WHITE};
  border-color: ${WHITE};
`;

const OrText = styled.div`
  color: ${WHITE};
  font-weight: light;
`;

const SummarySection = styled.div`
  background-color: ${(props) => props.stats ? `` : WHITE};
  height: 100%;
  text-align: center;
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:not(:first-child) {
    border-left: 1px solid ${WHITE};
  }

  ${media.medium`
    width: 100%;
    height: 4rem;

    &:not(:last-child) {
      border-left: none;
      border-bottom: 1px solid ${WHITE};
    }

    &:last-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
    }
  `}
`;

const SummaryHeader = styled.div`
  color: ${WHITE};
  font-weight: 800;
  font-size: .8rem;
`;

const SummaryInfo = styled.div`
  color: ${WHITE};
  font-weight: 100;
`;

const ProfileLink = styled(NavLink)`
  color: ${BLUE};
  font-weight: 800;
`;

export {
  UserSummaryBannerContainer,
  SummarySection,
  TrackingText,
  AuthButton,
  OrText,
  SummaryHeader,
  SummaryInfo,
  ProfileLink,
};
